import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

// Fetch course-specific Discord invite link.
export const getCourseDiscordInvite = async (courseId: string): Promise<string | null> => {
  try {
    const courseRef = doc(db, 'courses', courseId);
    const snap = await getDoc(courseRef);
    if (snap.exists()) {
      const data: any = snap.data();
      // Allow multiple possible storage places
      if (data.discordInviteUrl) return data.discordInviteUrl as string;
      if (data.discord && data.discord.inviteUrl) return data.discord.inviteUrl as string;
      if (data.zoomSettings?.inviteLink && /discord\.gg|discord\.com\//i.test(data.zoomSettings.inviteLink)) return data.zoomSettings.inviteLink;
    }
    return null;
  } catch (e) {
    console.error('Failed to fetch course discord invite', e);
    return null;
  }
};


